var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',[_c('h1',{on:{"click":_vm.goTop}},[_vm._v("点数計算ドリル")])])}
var staticRenderFns = []

export { render, staticRenderFns }